// extracted by mini-css-extract-plugin
export default {"container":"BaseChoose_container__rfOX3","body":"BaseChoose_body__xQ7e+","item":"BaseChoose_item__hz3kO","selectedValue":"BaseChoose_selectedValue__vjTKW"};